import { render, staticRenderFns } from "./statistical-analysis-view-detail.vue?vue&type=template&id=7532f430&scoped=true&"
import script from "./statistical-analysis-view-detail.ts?vue&type=script&lang=ts&"
export * from "./statistical-analysis-view-detail.ts?vue&type=script&lang=ts&"
import style0 from "./statistical-analysis-view-detail.scss?vue&type=style&index=0&id=7532f430&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7532f430",
  null
  
)

export default component.exports